<template>
  <v-container fluid>
    <v-row justify="center">
      <v-row class="top-banner pa-5" align="center">
        <v-col cols="4">
          <v-img src="https://swiset.com/wp-content/uploads/2021/09/Funding-Hunt-by-Swiset-white.svg" max-height="77"
                 position="center center" contain/>
        </v-col>
        <v-col cols="8">
          <h3 class="invitation">{{ $t('invitation') }}</h3>
        </v-col>
      </v-row>
    </v-row>
    <v-row align="center" justify="center" class="my-7">
      <v-col cols="4">
        <InitiateTest v-if="forexTest === null || forexTest === undefined" :first-created="firstCreatedForex" market="Forex"/>
        <SummaryTest v-else-if="activeTest(forexTest.participantStatus)" market="Forex" :test="forexTest"/>
        <FinishedTest v-else market="Forex" :test="forexTest"/>
      </v-col>
      <v-col cols="4">
        <InitiateTest v-if="futuresTest === null || futuresTest === undefined" :first-created="firstCreatedFutures" market="Futures"/>
        <SummaryTest v-else-if="activeTest(futuresTest.participantStatus)" market="Futures" :test="futuresTest"/>
        <FinishedTest v-else market="Futures" :test="futuresTest"/>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <p class="history-text" v-html="$tc((allTest.length > 0)? 'history.with' : 'history.without', allTest.length, { count: allTest.length })"/>
    </v-row>

    <!-- Overlay for Loading Funding tests!-->
    <v-overlay v-model="loadingFundingTests">
        <lottie :options="lottieOptions" :height="250" :width="250"/>
    </v-overlay>
  </v-container>
</template>

<script>
import * as animationData from '@/assets/animations/loading.json';
import Repository from '../../../../repositories/funding';
import InitiateTest from "@/views/Funding/Simulation/components/InitiateTest";
import SummaryTest from "@/views/Funding/Simulation/components/SummaryTest";
import FinishedTest from "@/views/Funding/Simulation/components/FinishedTest";
export default {
  name: "TestHome",
  components: {FinishedTest, SummaryTest, InitiateTest},
  data() {
    return {
      lottieOptions: { animationData: animationData.default, },
      loadingFundingTests: false,
      allTest: [],
      forexTest: null,
      firstCreatedForex: false,
      futuresTest: null,
      firstCreatedFutures: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadingFundingTests = true
      Repository.allFundingTestOfUser().then((response) => {
        if(response.status < 400) {
          this.allTest = response.data;

          // Forex Test
          let allForexTest = this.allTest.filter((test) => test.fundingEvaluation.fundingVendor.market.name === 'Forex');
          allForexTest.sort((a, b) => { return (a.id > b.id)? 1 : (a.id < b.id)? -1 : 0 });
          if(allForexTest.length > 0)
            this.forexTest = allForexTest[allForexTest.length - 1];
          this.firstCreatedForex = allForexTest.length > 0;

          // Futures Test
          let allFuturesTest = this.allTest.filter((test) => test.fundingEvaluation.fundingVendor.market.name === 'Futures');
          allFuturesTest.sort((a, b) => { return (a.id > b.id)? 1 : (a.id < b.id)? -1 : 0 });
          if(allFuturesTest.length > 0)
            this.futuresTest = allFuturesTest[allFuturesTest.length - 1];
          this.firstCreatedFutures = allFuturesTest.length > 0;
        }
        this.loadingFundingTests = false
      })
    },
    activeTest(participantStatus) {
      return participantStatus === 'ACTIVE' || participantStatus === 'PAUSED';
    },
    finishedTest(participantStatus) {
      return participantStatus === 'DISQUALIFIED' || participantStatus === 'ABANDONED' || participantStatus === 'WINNER';
    },
  }
}
</script>


<i18n>
{
  "en": {
    "title": "Funding Hunt ™",
    "invitation": "Don't lose more money in failed funding evaluations, use our free evaluation simulator to simulate popular evaluations and go to the hunting when you are ready.",
    "history": {
      "without": "You have not simulated any funding evaluation, go ahead and simulate your first evaluation!",
      "with": "You have simulated {count} funding evaluation | You have simulated {count} funding evaluations"
    }
  },
  "es": {
    "title": "Funding Hunt ™",
    "invitation": "No pierdas dinero perdiendo pruebas, utiliza nuestro simulador gratuito para simular las pruebas de fondeo más populares y sal al rodeo cuando estés listo.",
    "history": {
      "without": "No has simulado ninguna prueba de fondeo, ¡anímate a simular tu primera prueba!",
      "with": "Has simulado {count} prueba de fondeo | Has simulado {count} pruebas de fondeo"
    }
  }
}
</i18n>

<style lang="scss" scoped>
@import "src/global";

.top-banner {
  background: rgb(17,17,17);
  background: linear-gradient(153deg, rgba(17,17,17,1) 56%, rgba(0,247,132,1) 100%);
  border-radius: 17px;
  max-width: 70%;

  .invitation {
    color: #FFFFFF;
  }
}

.history-text {
  color: $subtitle-color;
}
</style>
